import {
    Component,
    ContentChild,
    ElementRef,
    forwardRef,
    Input,
    OnChanges,
    OnInit,
    TemplateRef,
    ViewChild
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { noop } from 'rxjs';
import { DictionaryItem } from '../../../../domain/dictionary.model';
import { LsnErrorStateMatcher } from '../error-state-matcher';

export const CUSTOM_SELECT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SelectComponent),
    multi: true
};

@Component({
    selector: 'app-select',
    styleUrls: ['./select.component.scss'],
    templateUrl: './select.component.html',
    providers: [CUSTOM_SELECT_CONTROL_VALUE_ACCESSOR]
})
export class SelectComponent implements ControlValueAccessor, OnInit, OnChanges {

    private onChangeCallback: (_: any) => void = noop;
    private onTouchedCallback: (_: any) => void = noop;

    @ContentChild(TemplateRef, {static: false}) optionTemplate;
    @ViewChild(MatSelect, {static: false}) matSelect;

    @ViewChild('filterInput') filterInput: ElementRef;
    @ViewChild('scrollingDiv') scrollingDiv: ElementRef;

    @Input() minSizeForFilter = 6;
    @Input() placeholder: string;
    @Input() label: string;
    @Input() hasEmpty = true;
    @Input() disabled = false;
    @Input() multiple = false;
    @Input() errorStateMatcher: LsnErrorStateMatcher;
    @Input() itemList: DictionaryItem[] = [];
    @Input() bindValue = 'code';
    @Input() bindDescription = 'description';
    @Input() slim = false;
    @Input() required = false;
    @Input() bindAsCode = false;
    @Input() autofocusFilter = true;

    search = '';
    value: any;
    filteredItemList: DictionaryItem[] = [];

    openedChange(opened) {
        this.search = '';
        this.filter(this.search);
        if (this.itemList.find(i => i[this.bindValue] === this.value)) {
            const index = this.itemList.map(i => i[this.bindValue]).indexOf(this.value);
            this.scrollingDiv.nativeElement.scrollTop = index * 42;
        }
        if (opened && this.autofocusFilter && this.isSearchEnabled) {
            this.filterInput.nativeElement.focus();
        }
    }

    compareFn(p1, p2) {
        if (this.multiple) {
            return p1 && p2
                ? p1.code === p2.code
                : p1 === p2;
        } else {
            return p1 === p2;
        }
    };


    ngOnInit() {
        this.filter(this.search);
    }

    ngOnChanges() {
        this.filter(this.search);
    }

    get isSearchEnabled() {
        return this.minSizeForFilter !== null && Array.isArray(this.itemList) && this.itemList.length > this.minSizeForFilter;
    }

    get errors() {
        return this.errorStateMatcher ? this.errorStateMatcher.errors : undefined;
    }

    update($value: any) {
        this.value = $value;
        this.writeValue($value);
        this.onChangeCallback($value);
        this.filter('');
    }

    writeValue($value: any) {
        this.value = $value;
    }

    registerOnChange(fn: any): void {
        this.onChangeCallback = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouchedCallback = fn;
    }

    filter(text: string) {
        this.filteredItemList =
            (this.itemList || []).filter(item => {
                const description = this.bindDescription ? item[this.bindDescription] : item;
                return description.toString().toLocaleUpperCase().indexOf(text.toLocaleUpperCase()) !== -1;
            });
    }

}
